<template>
  <div class="navbar">   
    <div class="menu">
      <button class="botaoMenu" @click.prevent="botaoMenu()"><img src="@/assets/imagens/menu.svg" alt="menu"></button>
    </div>

    <div v-if="this.home == true" :class="{'botoes': this.menu == false, 'aparecemenu': this.menu == true}">  
      <a @click.prevent="scrollTo('sec1')" :class="{'desaparece': this.menu == true}"><img :src="'/imagens/logosouzo3.png'" alt="logo" id="logo"></a>

      <a @click.prevent="scrollTo('sec1')" v-if="portugues">Início</a>
      <a @click.prevent="scrollTo('sec1')" v-else>Home</a>

      <a @click.prevent="scrollTo('sec2')" v-if="portugues">Sobre</a>
      <a @click.prevent="scrollTo('sec2')" v-else>About</a>

      <a @click.prevent="scrollTo('sec3')" v-if="portugues">Soluções</a>
      <a @click.prevent="scrollTo('sec3')" v-else>Services</a>

      <a @click.prevent="scrollTo('sec4')" v-if="portugues">Contato</a>
      <a @click.prevent="scrollTo('sec4')" v-else>Contact</a>
    </div>
    <div v-else :class="{'botoes': this.menu == false, 'aparecemenu': this.menu == true}">
      <router-link to="/" :class="{'desaparece': this.menu == true}"><img :src="'/imagens/logosouzo3.png'" alt="logo" id="logo"></router-link>

      <router-link to="/" v-if="portugues">Início</router-link>
      <router-link to="/" v-else>Home</router-link>
    </div>

    <div class="preferencia">      
      <div class="tema" v-if="this.portugues == true && this.diurno == true">
        <p>Noturno</p>
        <button class="botao" @click.prevent="tema()"> <img src="@/assets/imagens/lua.svg" alt="noturno"></button>
      </div>
      <div class="tema" v-if="this.portugues == false && this.diurno == true">
        <p>Dark</p>
        <button class="botao" @click.prevent="tema()"><img src="@/assets/imagens/lua.svg" alt="dark"></button>
      </div>

      <div class="tema" v-if="this.portugues == true && this.diurno == false">
        <p>Diurno</p>
        <button class="botao" @click.prevent="tema()"><img src="@/assets/imagens/sol.svg" alt="diurno"></button>
      </div>

      <div class="tema" v-if="this.portugues == false && this.diurno == false">
        <p>White</p>
        <button class="botao" @click.prevent="tema()"><img src="@/assets/imagens/sol.svg" alt="white"></button>
      </div>

      <p v-if="this.portugues == true">Translate</p>
      <p v-else>Traduzir</p>

      <button class="botao" v-if="this.portugues == false" @click.prevent="traduzir()">        
        <img class="bandeira" src="@/assets/imagens/brasil.jpg" alt="brasil"> 
      </button>

      <button class="botao" v-else @click.prevent="traduzir()">        
        <img class="bandeira" src="@/assets/imagens/usa.png" alt="usa">
      </button>

    </div>    

    <div class="cookie" v-if="this.cookie == false">
      <div v-if="this.portugues">
        <h3>Esse site usa cookies</h3>
        <p>Nos utilizamos cookies para armazenar temporariamente alguns dados para melhorar sua experiência. Para saber mais, acesse nossa <router-link class="link" to="/politica-de-privacidade">Política de Privacidade</router-link>.</p>
        <div class="botoesCookie">
          <button class="botaoOpcao" @click.prevent="botaoCookie('aceitar')">Aceitar</button>
          <button class="botaoOpcao" @click.prevent="botaoCookie('recusar')">Recusar</button>
        </div>

      </div>
      <div v-else>
        <h3>This Web Site use cookies</h3>
        <p>We use cookies to temporarily store some data to improve your experience. For more information, please read our <router-link class="link" to="/politica-de-privacidade">Privacy Policy</router-link>.</p>
        <div class="botoesCookie">
          <button class="botaoOpcao" @click.prevent="botaoCookie('aceitar')">Accept</button>
          <button class="botaoOpcao" @click.prevent="botaoCookie('recusar')">Decline</button>
        </div>
      </div>

    </div>   

  </div>

  <a class="whats" href="https://wa.me/5511978404500?text=Olá!" target="_blank">
      <img src="@/assets/imagens/whats.png" alt="whatsapp" class="whats-icon">
  </a>
  
</template>

<script>
import router from '@/router';
import { useUsuarioStore } from '../stores/autenticacao'; //pinia cookie do navegador

export default { 
  name: 'Navbar',  

  emits: ["traduzir", "cor"],

  data(){
      return{
          portugues: true,
          diurno: true,
          menu: false,
          cookie: false,
          home: true
      }
  },

  created(){
    this.atualiza();
    this.checaPagina();
  },

  methods: {
    scrollTo(id) {
    const el = document.getElementById(id);
    if (el) {
      const navbarHeight = document.querySelector(".navbar")?.offsetHeight || 0;
      const top = el.getBoundingClientRect().top + window.scrollY - navbarHeight;

      window.scrollTo({
        top,
        behavior: "smooth"
      });
    }
  },

    checaPagina(){
      const currentPath = window.location.pathname;

      if (currentPath === '/') {
        this.home = true;
      } else {
        this.home = false;
      }
    },

    atualiza(){
      const store = useUsuarioStore();

      this.portugues = store.portugues;
      this.diurno = store.diurno;
      this.cookie = store.cookie;
    },

    tema(){
      const store = useUsuarioStore();

      this.diurno = !this.diurno;
      store.noturno({diurno: this.diurno});
      this.$emit("cor", {cor: this.diurno});
    },

    traduzir(){
      const store = useUsuarioStore();

      this.portugues = !this.portugues;
      store.linguagem({portugues: this.portugues});
      this.$emit("traduzir", {traduzir: this.portugues});
    },

    botaoMenu(){
      this.menu = !this.menu;
    },

    botaoCookie(resposta){
      if(resposta == 'aceitar'){
        const store = useUsuarioStore();

        this.cookie = true;
        store.aceitoCookie();
      }
      else if(resposta == 'recusar'){
        this.cookie = true;
      }
    }
    
  }

}
</script>

<style src="./navbar.scss" lang="scss" scoped></style>
